/*!

=========================================================
* Vue Argon Dashboard PRO - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import store from './stores/store';
import { abilitiesPlugin } from '@casl/vue'
// router setup
import router from './routes/router';
// Filtros string en templates
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
numeral.register('locale', 'cl', {
  delimiters: {
      thousands: '.',
      decimal: ','
  },
  abbreviations: {
      thousand: 'k',
      million: 'm',
      billion: 'b',
      trillion: 't'
  },
  currency: {
      symbol: '$'
  }
});
import TreeView from "vue-json-tree-view"
Vue.use(TreeView)

import vRut from 'v-rut';
Vue.use(vRut)

import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {
  hideModules: { "headings": true, "code": true, "image": true, "removeFormat": true, "separator": true }
}); // config is optional. more below
// switch between locales
numeral.locale('cl');
Vue.filter('numFormat', numFormat(numeral));

Vue.config.productionTip = false
/**
* Sistema de permisos
*/
Vue.use(abilitiesPlugin)

//var FormulaParser = require('hot-formula-parser').Parser;
//var parser = new FormulaParser();
import moment from 'moment';

//Object.defineProperty(Vue.prototype, '$parser', {value: parser});
Object.defineProperty(Vue.prototype, '$moment', {value: moment});

router.beforeEach((to, from, next) => {
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    
    if (!store.getters.isLoggedIn) {
      next({
        name: 'Login',
      })
    } else {
      
      if( !store.getters.isUserLoaded ){
        
        store.dispatch("retrieveUser").then( response => {
          store.dispatch("retrieveCart").then( response => {} );
          next()
        }).catch(error => {
          next({ name: 'Login'});
        });
      } else {
        next({
          name: 'Login',
        })
      }
    }
  } else {
    next() // make sure to always call next()!
  }
})


// plugin setup
Vue.use(DashboardPlugin);

import VueSignature from 'vue-signature-pad';
Vue.use(VueSignature);

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

// Add a request interceptor
Vue.axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  store.commit('incrementLoadingStack');
  return config;
}, function (error) {
  store.commit('decrementLoadingStack');
  // Do something with request error
  return Promise.reject(error);
});
// Add a response interceptor
Vue.axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  store.commit('decrementLoadingStack');
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  store.commit('decrementLoadingStack');
  return Promise.reject(error);
});

import ImageUploader from 'vue-image-upload-resize'
Vue.use(ImageUploader);

import * as VueGoogleMaps from 'vue2-google-maps'
 
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBltrSCR6vrclMocW2qWtFuhRx_7tzpz0g',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
 
  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,
 
  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  //installComponents: true,
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
});
